import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";
import Button from "../Button/Button";
import AddSkillsModal from "@features/Profile/components/AddSkillsModal";

interface AddSkillsPromptModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const AddSkillsPromptModal: React.FC<AddSkillsPromptModalProps> = ({ isOpen, onClose }) => {
	const { t } = useTranslation();
	const [showAddSkillsModal, setShowAddSkillsModal] = useState(false);

	const handleAddSkills = () => {
		setShowAddSkillsModal(true);
	};

	const handleCloseAddSkills = () => {
		setShowAddSkillsModal(false);
		// Close the prompt modal after skills modal is closed
		onClose();
	};

	return (
		<>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
				showCloseIcon={true}
				width="max-w-md"
				padding="p-8"
				className="text-center">
				{/* Icon */}
				<div className="flex justify-center mb-6">
					<div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
						<svg
							className="w-8 h-8 text-accent"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg">
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
							/>
						</svg>
					</div>
				</div>

				{/* Title */}
				<h2 className="text-xl font-bold text-gray-900 mb-3">{t("common.ui.profileCompletedTitle")}</h2>

				{/* Description */}
				<p className="text-gray-600 mb-8">{t("common.ui.profileCompletedDescription")}</p>

				{/* Action Buttons */}
				<div className="flex gap-3">
					<Button
						text={t("common.ui.addSkills")}
						variant="primary"
						onClick={handleAddSkills}
						className="flex-1 py-3"
					/>
					<Button
						text={t("common.ui.maybeLater")}
						variant="tertiary"
						onClick={onClose}
						className="flex-1 py-3"
					/>
				</div>
			</Modal>

			{/* Add Skills Modal */}
			<AddSkillsModal open={showAddSkillsModal} onClose={handleCloseAddSkills} />
		</>
	);
};

export default AddSkillsPromptModal;
